import React, { useEffect } from "react";

// Step Arena Outdoor — Daily Pass (Hyrja Ditore).
// Mirror of stepsc-admin/.../DailyPassSection.js
export const DAILY_PASS_WEEKDAY_PRICE = 20;
export const DAILY_PASS_WEEKEND_PRICE = 25;

export const isWeekendISO = (iso) => {
    if (!iso) return false;
    const d = new Date(iso);
    if (isNaN(d.getTime())) return false;
    const day = d.getDay();
    return day === 0 || day === 6;
};

export const priceForEntryDate = (iso) => (isWeekendISO(iso) ? DAILY_PASS_WEEKEND_PRICE : DAILY_PASS_WEEKDAY_PRICE);

const todayIsoDate = () => new Date().toISOString().split("T")[0];

export const DailyPassSection = ({ formData, setFormData }) => {
    const entryDate = formData.entryDate || todayIsoDate();
    const weekend = isWeekendISO(entryDate);
    const price = priceForEntryDate(entryDate);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            entryDate: prev.entryDate || todayIsoDate(),
            totalAmount: price,
            payableAmount: price - (price * (Number(prev.discount) || 0)) / 100,
        }));
    }, [price, setFormData]);

    return (
        <div className="flex flex-col gap-5 p-5 border-2 border-blue-500 rounded-lg bg-blue-50">
            <h2 className="text-2xl font-bold text-blue-700">Hyrja Ditore — Step Arena Outdoor</h2>

            <div className="flex flex-col gap-2">
                <label className="font-medium text-gray-700">Data e hyrjes</label>
                <input
                    type="date"
                    value={entryDate}
                    onChange={(e) => setFormData((prev) => ({ ...prev, entryDate: e.target.value }))}
                    className="p-2 border rounded-md w-full md:w-1/3"
                />
            </div>

            <div className="flex flex-col gap-2">
                <label className="font-medium text-gray-700">RFID</label>
                <input
                    type="text"
                    value={formData.rfid || ""}
                    onChange={(e) => setFormData((prev) => ({ ...prev, rfid: e.target.value }))}
                    placeholder="Vendosni RFID"
                    className="p-2 border rounded-md w-full md:w-1/3"
                />
            </div>

            <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-600">
                    {weekend ? "Tarifa e fundjavës (E shtunë / E diel)" : "Tarifa e ditëve të javës (E hënë → E premte)"}
                </span>
                <span className="text-3xl font-bold text-blue-700">{price}€</span>
            </div>

            <div className="p-4 bg-white border border-blue-300 rounded-md">
                <div className="font-semibold text-gray-700 mb-1">Oferta përfshin:</div>
                <ul className="list-disc ml-5 text-gray-700">
                    <li>Shezlong</li>
                    <li>Peshqir</li>
                </ul>
            </div>
        </div>
    );
};

export default DailyPassSection;
